import { getKey } from '@helpers/env'
import { CollectionProduct as CollectionProductProps } from 'types/collection'
import CollectionProduct from '../CollectionProduct'
import styles from './styles.module.scss'

type CollectionProductListProps = {
  products: CollectionProductProps[]
}

function CollectionProductList({ products }: CollectionProductListProps) {
  return (
    <ul className={styles.productList__container}>
      {products.map(product => {
        return (
          <li
            key={getKey(product.id)}
            className="productList__item"
            data-testid={`productType-${product.product_type}`}
          >
            <CollectionProduct product={product} />
          </li>
        )
      })}
    </ul>
  )
}

export default CollectionProductList
